import { ChangePlayerInputModel } from './../models/change-player-input.model';
import { Injectable } from '@angular/core';
import { take } from 'rxjs/operators';

import { BsModalService } from 'ngx-bootstrap/modal';

import { ChangePlayerModalComponent } from './../containers/change-player-modal/change-player-modal.component';

@Injectable({
    providedIn: 'root'
})
export class ChangePlayerLauncherService {
    constructor(private bsModalService: BsModalService) {}

    openPlayersChangeModal(changePlayerInput: ChangePlayerInputModel, onHiddenCallback: () => any = null) {
        if (onHiddenCallback) {
            this.bsModalService.onHidden.pipe(take(1)).subscribe(() => {
                onHiddenCallback();
            });
        }

        this.bsModalService.show(ChangePlayerModalComponent, {
            id: 2,
            class: 'fullscreen',
            initialState: { changePlayerInput }
        });
    }
}
